module.exports = __webpack_public_path__ + "static/media/Major Project EXTC 2022-23.8e9e3ffb.pdf";